import Cloth from 'casino/playfields/Cloth';

const PickAPairGame = () => <Cloth>Pick a pair poker</Cloth>;

export default PickAPairGame;
